import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-03953ca0")
const _hoisted_1 = { class: "pdf-item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-break" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "商品汇总单", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "商品名称"),
    /*#__PURE__*/_createElementVNode("th", null, "数量"),
    /*#__PURE__*/_createElementVNode("th", null, "金额")
  ])
], -1)
_popScopeId()

import { ref, onMounted } from "vue"

export default /*#__PURE__*/_defineComponent({
  props: {
	initData:Array
},
  setup(__props) {

const props = __props

const pdfItem = ref<any>([])
const renderPage = (data: any) => {
	const categorizedObjects = Object.values(categorizeOrdersByPickupPoint(data))
	pdfItem.value = categorizedObjects.map((item: any) => {
		let obj = {
			productName: item[0]['商品'],
			number: 0,
			totalPrice:0
		}
		item.forEach((val:any)=>{
			obj.number+=Number(val['数量'])
			obj.totalPrice+=Number(val['商品金额'])
		})
		obj.totalPrice =Number(obj.totalPrice.toFixed(2))
		return obj
	});
}

function categorizeOrdersByPickupPoint(ordersArray: any) {
	const categorizedOrders: any = {};
	for (const order of ordersArray) {
		const pickupPoint = order["商品"];
		if (!categorizedOrders[pickupPoint]) {
			categorizedOrders[pickupPoint] = [];
		}
		categorizedOrders[pickupPoint].push(order);
	}
	return categorizedOrders;
}
onMounted(()=>{
	renderPage(props.initData)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("table", null, [
      _hoisted_4,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pdfItem.value, (item, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, _toDisplayString(item.productName), 1),
            _createElementVNode("td", null, _toDisplayString(item.number), 1),
            _createElementVNode("td", null, _toDisplayString(item.totalPrice), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})